import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { RolActividad } from './roles-actividad.model';

@Injectable({
  providedIn: 'root'
})
export class RolesActividadService {
  url: string;
  token: string;
  endpoint = 'rolesActividad';
  endpointVinculaciones = 'vinculacionesRolActividad';

  constructor(private http: HttpClient) {}

  getRolesActividad(): Observable<RolActividad[]> {
    return this.http.get<RolActividad[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  changeVinculacionesRolActividad(
    rolesActividad: RolActividad[]
  ): Observable<{ rolesActividad: RolActividad[] }> {
    return this.http.post<{ rolesActividad: RolActividad[] }>(
      `${this.url}/${this.endpointVinculaciones}/`,
      {
        rolesActividad: rolesActividad
      }
    );
  }

  addRolesActividad(roles: RolActividad): Observable<RolActividad> {
    return this.http.post<RolActividad>(`${this.url}/${this.endpoint}/`, {
      ...roles
    });
  }

  changeRolesActividad(p: RolActividad): Observable<RolActividad> {
    return this.http.patch<RolActividad>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        roles: p,
        token: this.token
      }
    );
  }

  deleteRolesActividad(p: RolActividad): Observable<RolActividad> {
    return this.http.delete<RolActividad>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }

  getRolesActividadesMock(): Observable<RolActividad[]> {
    const salida: RolActividad[] = [
      {
        id: 1,
        rol_id: 1,
        actividad_id: 1,
        vinculo_aprobado_rol: false,
        vinculo_aprobado_entidad_productiva: true,
        eliminado: false
      },
      {
        id: 2,
        rol_id: 1,
        actividad_id: 2,
        vinculo_aprobado_rol: false,
        vinculo_aprobado_entidad_productiva: true,
        eliminado: false
      },
      {
        id: 3,
        rol_id: 1,
        actividad_id: 3,
        vinculo_aprobado_rol: false,
        vinculo_aprobado_entidad_productiva: true,
        eliminado: false
      },
      {
        id: 4,
        rol_id: 1,
        actividad_id: 4,
        vinculo_aprobado_rol: false,
        vinculo_aprobado_entidad_productiva: false,
        eliminado: false
      }
    ];
    return of(salida);
  }
}
